import { render, staticRenderFns } from "./LicensesOverview.vue?vue&type=template&id=568e56d3&"
import script from "./LicensesOverview.vue?vue&type=script&lang=js&"
export * from "./LicensesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports